/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
export const DsBadge = /*@__PURE__*/ createReactComponent('ds-badge');
export const DsBarHorizontal = /*@__PURE__*/ createReactComponent('ds-bar-horizontal');
export const DsBarVertical = /*@__PURE__*/ createReactComponent('ds-bar-vertical');
export const DsButton = /*@__PURE__*/ createReactComponent('ds-button');
export const DsCard = /*@__PURE__*/ createReactComponent('ds-card');
export const DsConfirm = /*@__PURE__*/ createReactComponent('ds-confirm');
export const DsCountryDialog = /*@__PURE__*/ createReactComponent('ds-country-dialog');
export const DsCountryMultiple = /*@__PURE__*/ createReactComponent('ds-country-multiple');
export const DsDialog = /*@__PURE__*/ createReactComponent('ds-dialog');
export const DsDonut = /*@__PURE__*/ createReactComponent('ds-donut');
export const DsEmptyState = /*@__PURE__*/ createReactComponent('ds-empty-state');
export const DsError = /*@__PURE__*/ createReactComponent('ds-error');
export const DsEthAvatar = /*@__PURE__*/ createReactComponent('ds-eth-avatar');
export const DsEthWallet = /*@__PURE__*/ createReactComponent('ds-eth-wallet');
export const DsEtherscanLink = /*@__PURE__*/ createReactComponent('ds-etherscan-link');
export const DsExplorerLink = /*@__PURE__*/ createReactComponent('ds-explorer-link');
export const DsFieldset = /*@__PURE__*/ createReactComponent('ds-fieldset');
export const DsForm = /*@__PURE__*/ createReactComponent('ds-form');
export const DsIcon = /*@__PURE__*/ createReactComponent('ds-icon');
export const DsInputBignumber = /*@__PURE__*/ createReactComponent('ds-input-bignumber');
export const DsInputCheckbox = /*@__PURE__*/ createReactComponent('ds-input-checkbox');
export const DsInputDate = /*@__PURE__*/ createReactComponent('ds-input-date');
export const DsInputDatePicker = /*@__PURE__*/ createReactComponent('ds-input-date-picker');
export const DsInputDateRange = /*@__PURE__*/ createReactComponent('ds-input-date-range');
export const DsInputDatetime = /*@__PURE__*/ createReactComponent('ds-input-datetime');
export const DsInputFile = /*@__PURE__*/ createReactComponent('ds-input-file');
export const DsInputFileMultiple = /*@__PURE__*/ createReactComponent('ds-input-file-multiple');
export const DsInputImage = /*@__PURE__*/ createReactComponent('ds-input-image');
export const DsInputNumber = /*@__PURE__*/ createReactComponent('ds-input-number');
export const DsInputRadio = /*@__PURE__*/ createReactComponent('ds-input-radio');
export const DsInputString = /*@__PURE__*/ createReactComponent('ds-input-string');
export const DsLineOverTime = /*@__PURE__*/ createReactComponent('ds-line-over-time');
export const DsLoader = /*@__PURE__*/ createReactComponent('ds-loader');
export const DsLogo = /*@__PURE__*/ createReactComponent('ds-logo');
export const DsNumber = /*@__PURE__*/ createReactComponent('ds-number');
export const DsPagination = /*@__PURE__*/ createReactComponent('ds-pagination');
export const DsPie = /*@__PURE__*/ createReactComponent('ds-pie');
export const DsProgress = /*@__PURE__*/ createReactComponent('ds-progress');
export const DsQrcode = /*@__PURE__*/ createReactComponent('ds-qrcode');
export const DsRadioToggle = /*@__PURE__*/ createReactComponent('ds-radio-toggle');
export const DsSelect = /*@__PURE__*/ createReactComponent('ds-select');
export const DsSelectCountry = /*@__PURE__*/ createReactComponent('ds-select-country');
export const DsSelectMultiple = /*@__PURE__*/ createReactComponent('ds-select-multiple');
export const DsSelectOption = /*@__PURE__*/ createReactComponent('ds-select-option');
export const DsSelectSimple = /*@__PURE__*/ createReactComponent('ds-select-simple');
export const DsSparkline = /*@__PURE__*/ createReactComponent('ds-sparkline');
export const DsSpinner = /*@__PURE__*/ createReactComponent('ds-spinner');
export const DsSplitTag = /*@__PURE__*/ createReactComponent('ds-split-tag');
export const DsTab = /*@__PURE__*/ createReactComponent('ds-tab');
export const DsTable = /*@__PURE__*/ createReactComponent('ds-table');
export const DsTabs = /*@__PURE__*/ createReactComponent('ds-tabs');
export const DsTag = /*@__PURE__*/ createReactComponent('ds-tag');
export const DsTextArea = /*@__PURE__*/ createReactComponent('ds-text-area');
export const DsTextEditor = /*@__PURE__*/ createReactComponent('ds-text-editor');
export const DsToast = /*@__PURE__*/ createReactComponent('ds-toast');
export const DsTokenSelector = /*@__PURE__*/ createReactComponent('ds-token-selector');
export const DsTokenSubscription = /*@__PURE__*/ createReactComponent('ds-token-subscription');
export const DsTooltip = /*@__PURE__*/ createReactComponent('ds-tooltip');
export const DsUserMenu = /*@__PURE__*/ createReactComponent('ds-user-menu');
